module.exports = __webpack_public_path__ + "static/media/file-copy-alt.26065b73.svg";